import { useEffect } from "react";
import { useRawTable } from "../../hooks";
import moment from "moment";

export default function Module_ElderlyHealthCheckup_ElderlyHealthCheckupList({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
  exportData = [],
  totalRecord,
  callMainAPI,
  isResetPage,
}) {
  const { setTbData, setTbFirstIndex, renderTable } = useRawTable({
    setting: moduleData,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!isResetPage) return;

    setTbFirstIndex(0);
  }, [isResetPage]);

  useEffect(() => {
    if (!apiData) return;

    let formatData = apiData.map((item) => ({
      ...item,
      StudyDate: moment(item.StudyDate).format("YYYY-MM-DD"),
    }));

    const formatDetail = (data) => {
      if (!data) return null;

      return data.map((item) => ({
        ...item,
        StudyDate: moment(item.StudyDate).format("YYYY-MM-DD"),
      }));
    };

    setTbData({
      raw: formatDetail(apiData),
      format: null,
      export: formatDetail(exportData),
      totalRecord,
    });
  }, [apiData, exportData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
        isPaginator: true,
        callMainAPI,
      })}
    </>
  );
}
